/**
 * @description 投资模块 API
 */
const prefix = process.env.VUE_APP_API_DATAS
export default ({ request }) => ({
  // 理念关于
  philosophyAbout(params = {}) {
    return request({
      url: `${prefix}/philosophyAbout`,
      method: 'get',
      params
    })
  },
  // 投资策略
  investmentStrategy(params = {}) {
    return request({
      url: `${prefix}/investmentStrategy`,
      method: 'get',
      params
    })
  },
  // 投资系统
  investmentSystem(params = {}) {
    return request({
      url: `${prefix}/investmentSystem`,
      method: 'get',
      params
    })
  },
  // 投资者教育
  investorEducation(params = {}) {
    return request({
      url: `${prefix}/investorEducation`,
      method: 'get',
      params
    })
  },
})
